import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(all)/error.tsx");
